const types = require('../../constants/actionTypes');

const periodChanged = ({ period }) => ({
    type: types.GROWTH_PERIOD_CHANGED,
    payload: { period },
});

module.exports = periodChanged;
